/*
 * @version: V1.0.0
 * @Date: 2023-10-31 09:07:06
 * @LastEditors: lzq
 * @LastEditTime: 2023-11-06 15:52:12
 * @company: 睿展数据
 * @FilePath: \udi-wms-client\src\api\common\index.js
 * @Descripttion:
 */
import request from '@/utils/request'

// 获取字典
export function getDict(data) {
  return request({
    url: '/system/dictData/list',
    method: 'get',
    params: data
  })
}

// 下载 操作手册
export function getOperateFile(params) {
  return request({
    url: '/udi/attachment/downloadFileName',
    method: 'get',
    params,
    responseType: 'blob'
  })
}
